class LocalStorage {

    static saveItem<T>(key: string, value: T): boolean {
        localStorage.setItem(key, JSON.stringify(value))
        return true;
    }

    static getItem<T>(key: string): Promise<T | null> {

        if (!key) return Promise.reject(null);

        const item = localStorage.getItem(key);

        if (!item) return Promise.reject(null);

        try {
            return Promise.resolve(JSON.parse(item) as T);
        } catch (e) {
            return Promise.reject(null);
        }
    }

    static removeItem<T>(key: string): boolean {
        localStorage.removeItem(key);
        return true;
    }
}

export default LocalStorage;